import React from 'react';
import { TextVariant } from '@naf/text';
import { Accordion } from '@naf-simba/elements-accordion';
import { FAQGlobalReferenceType } from '../../../../../../../../types/FAQGlobalReferenceType';
import { BlockContentContext } from '../../../../BlockContent.utils';
import { ArticleBlockContentGridCol } from '../ArticleBlockContentGridCol';
import { useWindowLocation } from '../../../../../../hooks/Window/useWindowLocation';
import BlockContent from '../../../../BlockContent';
import SchemaFAQ from '../../../../../structured-data/SchemaFAQ';
import * as S from './Styles';

interface FAQGlobalReferenceSerializerProps {
  value: FAQGlobalReferenceType;
}

export const FAQGlobalReference = ({ value }: FAQGlobalReferenceSerializerProps) => {
  const path = useWindowLocation();
  const { title, body, faqItems } = value;

  if (!value) return null;

  return (
    <S.FAQWrapper>
      {title && <S.FAQTitle variant={TextVariant.Header3}>{title}</S.FAQTitle>}
      {faqItems?.length &&
        faqItems.map((item) => (
          <Accordion headingLevel={3} key={item._id || item._key} title={item?.question} className="accordion">
            <S.AccordionContent>{item.answer && <BlockContent value={item.answer} />}</S.AccordionContent>
          </Accordion>
        ))}
      {body && (
        <S.BodyContentWrapper>
          <BlockContent value={body} />
        </S.BodyContentWrapper>
      )}
      <SchemaFAQ faq={value} url={path} />
    </S.FAQWrapper>
  );
};

export const FAQGlobalReferenceSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: FAQGlobalReferenceSerializerProps) => (
      <ArticleBlockContentGridCol>
        <FAQGlobalReference value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: FAQGlobalReferenceSerializerProps) => <FAQGlobalReference value={value} />;
};
